<template>
  <!--
    The trial countdown in the header (Muhammad, 21 Sep 2026): Direct trial
    admins see how many days their free trial has left, and a way to buy.
    Reads the numeric days the API sends with the profile
    (trial_days_remaining, calendar days: 0 = ends today, negative =
    expired); falls back to the legacy "Your trial will expire in N days"
    sentence on an older API. Renders nothing for paid accounts, learners
    and the partner app. The day-before email (company:trial-expiry-reminders)
    uses the same arithmetic, so "1 day left" here is the day the email goes.
  -->
  <div v-if="visible" class="trial-countdown" :class="{ 'is-urgent': urgent, 'is-expired': expired }" data-tour="trial-countdown">
    <v-icon small class="trial-countdown__icon">{{ expired ? 'mdi-alert-circle' : 'mdi-timer-sand' }}</v-icon>
    <span class="trial-countdown__text">{{ label }}</span>
    <router-link :to="buyRoute" class="trial-countdown__buy">Buy IMPROVE</router-link>
  </div>
</template>

<script>
export default {
  name: "TrialCountdown",
  computed: {
    days() {
      const n = this.$store.getters.trialDaysRemaining;
      if (typeof n === "number" && !isNaN(n)) return n;
      // Older API: the sentence only.
      const s = String(this.$store.getters.trialDays || "");
      if (/expire today/i.test(s)) return 0;
      if (/is expired/i.test(s)) return -1;
      const m = s.match(/(\d+)\s*day/);
      return m ? parseInt(m[1], 10) : null;
    },
    visible() {
      if (this.$globalConfig.APP_NAME !== "direct") return false;
      if (Number(this.$store.getters.level) !== 2) return false;
      const state = Number(this.$store.getters.companyState);
      return (state === 1 || state === 2) && this.days !== null;
    },
    expired() {
      return this.days < 0 || Number(this.$store.getters.companyState) === 2;
    },
    urgent() {
      return !this.expired && this.days <= 3;
    },
    // The in-app purchase page (/billing) is on staging only so far; where the
    // router does not know it, the Account status page carries the plan.
    buyRoute() {
      const r = this.$router.resolve("/billing");
      return r && r.route && r.route.matched.length ? "/billing" : "/admin/finance/account-status";
    },
    label() {
      if (this.expired) return "Free trial ended";
      if (this.days === 0) return "Free trial ends today";
      if (this.days === 1) return "Free trial: 1 day left";
      return "Free trial: " + this.days + " days left";
    },
  },
};
</script>

<style scoped>
.trial-countdown {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-right: 12px;
  padding: 4px 6px 4px 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.16);
  color: #fff;
  font-size: 13px;
  white-space: nowrap;
}

.trial-countdown__icon {
  color: #fff !important;
}

.trial-countdown__text {
  font-weight: 600;
}

.trial-countdown__buy {
  padding: 3px 10px;
  border-radius: 999px;
  background: #fff;
  color: #002458;
  font-weight: 700;
  font-size: 12px;
  text-decoration: none;
  text-transform: none;
}

.trial-countdown.is-urgent {
  background: #c8641a;
}

.trial-countdown.is-expired {
  background: #b3261e;
}

@media (max-width: 959px) {
  .trial-countdown__text {
    display: none;
  }
  .trial-countdown {
    padding-left: 8px;
    margin-right: 6px;
  }
}
</style>
